var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { vote as fetchVote, fetchSurveyState, fetchSurvey, } from '../../api/surveys';
import { mapObject } from '../../utils/records';
import { isSurveyEnabled, } from './types';
import { getDetailedSurvey, getVotingResults, SURVEY_FETCH_TIMEOUT, SURVEY_MIN_UPDATE, surveySliceName, } from './utils';
import { shouldFetch } from '../../reducers/factory';
import { DEFAULT_FETCH_STATUS, getFailedFetchStatus, getInProgressFetchStatus, getSuccessfulFetchStatus, } from '../../utils/fetchStatus';
import { addPurchase } from '../../actions/PurchaseActions';
import { defaultSurveySelector, surveySelector } from './selectors';
var name = surveySliceName;
/**
 * Used to fetch the "default" survey, without proving survey id or alias.
 * If fetch is completed and the survey is not disabled its id is used to fetch current voting state
 * if user has already voted or the survey is no longer available.
 */
export var fetchDefaultSurvey = createAsyncThunk('survey/fetchDefault', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var getState, rejectWithValue, _a, apiUrl, token, survey, votes;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                getState = thunkAPI.getState, rejectWithValue = thunkAPI.rejectWithValue;
                _a = getState().auth, apiUrl = _a.apiUrl, token = _a.token;
                if (!apiUrl) {
                    return [2 /*return*/, rejectWithValue(undefined)];
                }
                return [4 /*yield*/, fetchSurvey(apiUrl)];
            case 1:
                survey = _b.sent();
                if (!isSurveyEnabled(survey)) {
                    return [2 /*return*/, survey];
                }
                return [4 /*yield*/, fetchSurveyState(apiUrl, token, survey._id)];
            case 2:
                votes = (_b.sent()).votes;
                survey.votes = votes;
                return [2 /*return*/, survey];
        }
    });
}); });
export var fetchSurveyByIdOrAlias = createAsyncThunk('survey/fetchByIdOrAlias', function (idOrAlias, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var getState, rejectWithValue, fulfillWithValue, _a, apiUrl, token, _b, votes, survey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                getState = thunkAPI.getState, rejectWithValue = thunkAPI.rejectWithValue, fulfillWithValue = thunkAPI.fulfillWithValue;
                _a = getState().auth, apiUrl = _a.apiUrl, token = _a.token;
                if (!apiUrl) {
                    return [2 /*return*/, rejectWithValue(undefined, idOrAlias)];
                }
                return [4 /*yield*/, fetchSurveyState(apiUrl, token, idOrAlias)];
            case 1:
                _b = _c.sent(), votes = _b.votes, survey = _b.voting;
                if (!survey) {
                    return [2 /*return*/, rejectWithValue(undefined, idOrAlias)];
                }
                if (!isSurveyEnabled(survey)) {
                    return [2 /*return*/, fulfillWithValue(survey, idOrAlias)];
                }
                survey.votes = votes;
                return [2 /*return*/, fulfillWithValue(survey, idOrAlias)];
        }
    });
}); }, {
    getPendingMeta: function (_a) {
        var idOrAlias = _a.arg;
        return idOrAlias;
    },
});
export var vote = createAsyncThunk('survey/vote', function (_a, thunkAPI) {
    var value = _a.value, surveyId = _a.surveyId;
    var getState = thunkAPI.getState, dispatch = thunkAPI.dispatch, rejectWithValue = thunkAPI.rejectWithValue;
    var _b = getState().auth, apiUrl = _b.apiUrl, token = _b.token;
    if (!apiUrl || !token) {
        return rejectWithValue(undefined);
    }
    return fetchVote(apiUrl, token, surveyId, value).then(function (_a) {
        var votes = _a.votes, survey = _a.survey, purchase = _a.purchase;
        if (purchase) {
            dispatch(addPurchase(purchase));
        }
        survey.votes = votes;
        return { purchase: purchase, survey: survey };
    });
});
export function fetchDefaultSurveyIfNeeded() {
    return function (dispatch, getState) {
        var defaultSurveyState = defaultSurveySelector(getState());
        var survey = defaultSurveyState.survey, defaultSurveyFetchStatus = __rest(defaultSurveyState, ["survey"]);
        var shouldRefetch = shouldFetch({
            fetchStatus: defaultSurveyFetchStatus,
            fetchTimeout: SURVEY_FETCH_TIMEOUT,
            minUpdate: SURVEY_MIN_UPDATE,
        });
        if (shouldRefetch) {
            return dispatch(fetchDefaultSurvey()).unwrap();
        }
        return Promise.resolve();
    };
}
export function fetchSurveyByIdIfNeeded(idOrAlias) {
    return function (dispatch, getState) {
        var selectedSurveyState = surveySelector(getState(), idOrAlias);
        var _a = selectedSurveyState !== null && selectedSurveyState !== void 0 ? selectedSurveyState : {}, survey = _a.survey, selectedSurveyFetchStatus = __rest(_a, ["survey"]);
        var shouldRefetch = shouldFetch({
            fetchStatus: selectedSurveyFetchStatus,
            fetchTimeout: SURVEY_FETCH_TIMEOUT,
            minUpdate: SURVEY_MIN_UPDATE,
        });
        if (shouldRefetch) {
            return dispatch(fetchSurveyByIdOrAlias(idOrAlias)).unwrap();
        }
        return Promise.resolve();
    };
}
var INITIAL_STATE = {
    // the survey fetched from `/v1/surveys`
    defaultSurvey: DEFAULT_FETCH_STATUS,
    // aggregate object for all surveys with ids/aliases as keys and surveys as values
    items: {},
    // alias to id map
    aliases: {},
};
export var surveysSlice = createSlice({
    name: name,
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchDefaultSurvey.pending, function (state) {
            state.defaultSurvey.fetchingInProgressSince = Date.now();
        })
            .addCase(fetchDefaultSurvey.fulfilled, function (state, action) {
            var survey = action.payload;
            var _a = state.defaultSurvey, _ = _a.survey, defaultSurveyFetchStatus = __rest(_a, ["survey"]);
            var detailedSurvey = getDetailedSurvey(survey);
            var fetchedSurvey = __assign({ survey: detailedSurvey }, getSuccessfulFetchStatus(defaultSurveyFetchStatus));
            state.defaultSurvey = fetchedSurvey;
            if (isSurveyEnabled(survey)) {
                state.items[survey._id] = fetchedSurvey;
                if (survey.urlAlias) {
                    state.aliases[survey.urlAlias] = survey._id;
                }
            }
        })
            .addCase(fetchDefaultSurvey.rejected, function (state) {
            var _a = state.defaultSurvey, survey = _a.survey, defaultSurveyFetchStatus = __rest(_a, ["survey"]);
            state.defaultSurvey = __assign({ survey: survey }, getFailedFetchStatus(defaultSurveyFetchStatus));
        })
            .addCase(fetchSurveyByIdOrAlias.pending, function (state, action) {
            var _a;
            var idOrAlias = action.meta.arg;
            var surveyKey = (_a = state.aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
            var _b = state.items, _c = surveyKey, surveyItem = _b[_c];
            var _d = surveyItem !== null && surveyItem !== void 0 ? surveyItem : {}, survey = _d.survey, surveyFetchStatus = __rest(_d, ["survey"]);
            state.items[surveyKey] = getInProgressFetchStatus(surveyItem ? surveyFetchStatus : DEFAULT_FETCH_STATUS);
        })
            .addCase(fetchSurveyByIdOrAlias.fulfilled, function (state, action) {
            var _a;
            var idOrAlias = action.meta.arg, survey = action.payload;
            var surveyKey = (_a = state.aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
            var _b = state.items, _c = surveyKey, prevItem = _b[_c];
            var _ = prevItem.survey, surveyFetchState = __rest(prevItem, ["survey"]);
            var detailedSurvey = getDetailedSurvey(survey);
            if (isSurveyEnabled(detailedSurvey) && detailedSurvey.urlAlias) {
                state.aliases[detailedSurvey.urlAlias] = detailedSurvey._id;
            }
            var surveyId = isSurveyEnabled(detailedSurvey)
                ? detailedSurvey._id
                : surveyKey;
            state.items[surveyId] = __assign(__assign({}, getSuccessfulFetchStatus(surveyFetchState)), { survey: detailedSurvey });
        })
            .addCase(fetchSurveyByIdOrAlias.rejected, function (state, action) {
            var _a;
            var idOrAlias = action.meta.arg;
            var surveyKey = (_a = state.aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
            var _b = state.items[surveyKey], survey = _b.survey, surveyFetchState = __rest(_b, ["survey"]);
            state.items[surveyKey] = __assign({ survey: survey }, getFailedFetchStatus(surveyFetchState));
        })
            .addCase(vote.fulfilled, function (state, action) {
            var survey = action.payload.survey, surveyId = action.meta.arg.surveyId;
            var _a = state.items[surveyId] || {}, detailedSurvey = _a.survey, surveyFetchStatus = __rest(_a, ["survey"]);
            if (!detailedSurvey || !isSurveyEnabled(detailedSurvey)) {
                return;
            }
            detailedSurvey.votingResults = getVotingResults(detailedSurvey.votingOptions, survey.votes);
            state.items[surveyId] = __assign({ survey: detailedSurvey }, getSuccessfulFetchStatus(surveyFetchStatus));
            var isDefaultSurvey = state.defaultSurvey.survey &&
                isSurveyEnabled(state.defaultSurvey.survey) &&
                state.defaultSurvey.survey._id === surveyId;
            if (isDefaultSurvey) {
                state.defaultSurvey = state.items[surveyId];
            }
        })
            .addCase('LOGOUT_SUCCESSFUL', function (state) {
            if (state.defaultSurvey.survey &&
                isSurveyEnabled(state.defaultSurvey.survey)) {
                state.defaultSurvey.survey.votes = null;
                state.defaultSurvey.survey.votingResults = null;
            }
            state.items = mapObject(state.items, function (idOrAlias, surveyItem) {
                if (!surveyItem.survey ||
                    (surveyItem.survey && !isSurveyEnabled(surveyItem.survey))) {
                    return surveyItem;
                }
                return __assign(__assign({}, surveyItem), { survey: __assign(__assign({}, surveyItem.survey), { votes: null, votingResults: null }) });
            });
        })
            .addMatcher(function (action) { return ['SET_LANGUAGE', 'LOGIN_SUCCESSFUL'].includes(action.type); }, function (state) {
            if (state.defaultSurvey.survey) {
                state.defaultSurvey.didInvalidate = true;
            }
            state.items = mapObject(state.items, function (idOrAlias, surveyItem) { return (__assign(__assign({}, surveyItem), { didInvalidate: true })); });
        });
    },
});
export default (_a = {}, _a[surveySliceName] = surveysSlice.reducer, _a);
